import axios from "axios";
import Cookies from "js-cookie";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";

const token = Cookies.get("thoth_token");

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_SIA_API_URL,
  headers: {
    Authorization: token ? token : null,
    withCredentials: true,
  },
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.data && error.response.data.errors) {
      const errors = error.response.data.errors;

      Object.keys(errors).forEach((field) => {
        errors[field].forEach((msg) => {
          toast.error(msg, { autoClose: 4000, theme: "dark" });
        });
      });
    } else if (error.message) {
      toast.error(error.message, { autoClose: 4000 });
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
